import FoldersEditView from '../../folders/folders-edit.html';
import FoldersFilesEditView from '../../folders/files-edit.html';
import ReportsPreviewView from '../../reports/reports-preview.html';

/**
 * Created by jorge.pena on 22-07-2015.
 */
angular.module('modal', ['ngSanitize'])

    .controller('ModalInstanceCtrl', ['$scope', '$uibModalInstance', 'options', function ($scope, $uibModalInstance, options) {


        $scope.options = options;

        $scope.onAccept = function () {
            $uibModalInstance.dismiss('cancel');
            $scope.options.onAccept($scope.options);
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
            if (typeof $scope.options.onCancel != "undefined") $scope.options.onCancel($scope.options);
        };

    }])

    .controller('ModalSendMailCtrl', ['$scope', '$uibModalInstance', '$http', 'options', 'Restangular', '$filter', 'LoginService', 'Upload', 'logService',
        function ($scope, $uibModalInstance, $http, options, Restangular, $filter, LoginService, Upload, logService) {
            $scope.mail = {
                addresses: options.to,
                content: options.content,
                subject: options.subject,
                module: options.module,
                code: options.code,
            cc: [],
            cco: [],
            cc_tmp: options.cc,
            cco_tmp: options.cco,
            message: options.message,
            files: [],
            attachments: []
        }

        $scope.message = $scope.mail.message;
        $scope.replyMailsAccounts = [];
        var user_mail = "";

        Restangular.all('MailAccounts').getList().then(function (mailsAccounts) {
            $scope.mailsAccounts = mailsAccounts;
        });

        //Cuenta del usuario
        Restangular.one('Users/Mail', LoginService.get("userId")).get().then(function (mail) {
            user_mail = mail;
        });


        let languageCode = "es"; //$translate.use().toLowerCase();
        $scope.tinymceOptions = {
            resize: true,
            forced_root_block: false,
            height: 100,
            contextmenu: false,
            branding: false,
            body_class: 'custom_tinymce_content',
            valid_classes: 'razor_expression',
            language: languageCode,
            paste_as_text: true,
            plugins: 'paste autoresize textcolor image lists advlist table noneditable code',
            toolbar: "undo redo | alignleft aligncenter alignright alignjustify | bold italic forecolor backcolor fontsizeselect | bullist numlist outdent indent | table | image | mybutton | code",
            menubar: false,
            statusbar: false,
            content_css: [
                '~/Content/events.css',
            ]
        };

        $scope.options = options;

        $scope.changeReplies = function () {
            $scope.replyMailsAccounts = [];
            $scope.replyMailsAccounts.push(_.find($scope.mailsAccounts, function (account) { return $scope.mail.mail_account_id == account.id; }).email);
            $scope.mail.reply_to = $scope.replyMailsAccounts[0];
            $scope.replyMailsAccounts.push(user_mail);
        }

        $scope.newAttachment = function (file) {
            if (file != null) { $scope.mail.files.unshift(file); }
        }

        $scope.deleteAttachment = function (item) {
            var index = $scope.mail.files.indexOf(item);
            $scope.mail.files.splice(index, 1);
        }


        $scope.onAccept = function () {
            if (angular.isUndefined($scope.mail.addresses)) $scope.mail.addresses = "";
            if (angular.isUndefined($scope.mail.cc_tmp)) $scope.mail.cc_tmp = "";
            if (angular.isUndefined($scope.mail.cco_tmp)) $scope.mail.cco_tmp = "";

            if ($scope.mail.addresses == "" && $scope.mail.cc_tmp == "" && $scope.mail.cco_tmp == "") {
                $scope.message = $filter('translate')('mail.missing_mail_to_cco_cc');
            } else {
                if (angular.isDefined($scope.mail.addresses))
                    $scope.mail.to = $scope.mail.addresses.split(",");
                if (angular.isDefined($scope.mail.cc_tmp))
                    $scope.mail.cc = $scope.mail.cc_tmp.split(",");
                if (angular.isDefined($scope.mail.cco_tmp))
                    $scope.mail.cco = $scope.mail.cco_tmp.split(",");

                if ($scope.mail.files.length > 0) {
                    Upload.base64DataUrl($scope.mail.files).then(function (urls) {
                        for (var i = 0; i < urls.length; i++) {
                            $scope.mail.attachments.push({
                                name: $scope.mail.files[i].name,
                                content: urls[i]
                            })
                        }
                        send();
                    });
                } else {
                    send();
                }

            }

        };

        var send = function () {
            $http({
                method: 'post',
                url: (window as any).CONFIG.api_url + 'Mail/SendMail',
                data: $scope.mail
            }).success(function (results, status, headers, config) {
                $uibModalInstance.dismiss('cancel');
                $scope.options.onAccept($scope.options);
            }).error(function (results, status, headers, config) {
            });
        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])

    .controller("ModalAddImageCtrl", ['Restangular', '$scope', '$uibModal', '$uibModalInstance', 'options', 'logService',
        function (Restangular, $scope, $uibModal, $uibModalInstance, options, logService) {

        logService.debug(options);

        $scope.options = options;
        $scope.image = "";

        $scope.currentGeneralFolderId = null; //carpeta actual general
        $scope.generalFolders = []; //carpetas generales
        $scope.generalFiles = []; //imagenes de la carpeta actual general
        $scope.currentEventFolderId = null; //carpeta actual evento
        $scope.eventFolders = []; //carpetas del evento
        $scope.eventFiles = []; //imagenes de la carpeta actual de evento

        //cargamos las imagenes de la biblioteca de archivos privados generales
        $scope.loadGeneralData = function (folderId, level, is_public) {
            options = { folder_id: folderId, entity_type: 'general', entity_type_id: null, is_public: is_public };
            $scope.currentGeneralFolderId = folderId;
            Restangular.all("Folders").getList(options).then(function (results) {
                let newFolders = results.filter(m=>m.is_folder && $scope.generalFolders.find(f=>f.id==m.id)==null);
                newFolders.forEach(f=>{
                    f.level = level;
                });
                $scope.generalFolders = [...$scope.generalFolders, ...newFolders];
                $scope.generalFiles = results.filter(m=>(!m.is_folder || (m.mimetype!=null && m.mimetype?.indexOf("image") > -1)));
            });
        };

        //cargamos las imagenes de la biblioteca de la carpeta actual
        $scope.loadGeneralData($scope.currentGeneralFolderId, 1, false);

        //cargamos las imagenes de la biblioteca de archivos privados generales
        $scope.loadEventData = function (folderId, level, is_public) {
            options = { folder_id: folderId, entity_type: 'events', entity_type_id: $scope.options.event_id, is_public: is_public };
            $scope.currentEventFolderId = folderId;
            Restangular.all("Folders").getList(options).then(function (results) {
                let newFolders = results.filter(m=>m.is_folder && $scope.generalFolders.find(f=>f.id==m.id)==null);
                newFolders.forEach(f=>{
                    f.level = level;
                });
                $scope.eventFolders = [...$scope.eventFolders, ...newFolders];
                $scope.eventFiles = results.filter(m=>(!m.is_folder || (m.mimetype!=null && m.mimetype?.indexOf("image") > -1)));
            });
        };
        
        //cargamos las imagenes de la biblioteca de la carpeta actual
        if($scope.options.event_id!=null) $scope.loadEventData($scope.currentEventFolderId, 1, false);

        //cerrar dialogo
        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
            if (typeof $scope.options.onCancel != "undefined") $scope.options.onCancel($scope.options);
        };

        //seleccion de imagen
        $scope.selectImage = function(image){
            $uibModalInstance.dismiss('cancel');
            $scope.options.onAccept(image);
        };

        //añadir
        $scope.editAdd = function (type, currentFolderId, id, entity_type, entity_type_id, is_public) {
            let $modalInstance = null;
            if (type == 'folder') {
                $modalInstance = $uibModal.open({
                    animation: true,
                    template: FoldersEditView,
                    size: "md",
                    controller: "FoldersEditModalCtrl",
                    scope: $scope,
                    resolve: {
                        folderId: function () {
                            return id;
                        },
                        parentFolderId: function () {
                            return currentFolderId;
                        },
                        entity_type: function () {
                            return entity_type
                        },
                        entity_type_id: function () {
                            return entity_type_id
                        },
                        is_public: function () {
                            return is_public
                        }
                    }
                });
            } else {
                $modalInstance = $uibModal.open({
                    animation: true,
                    template: FoldersFilesEditView,
                    size: "md",
                    controller: "FilesEditModalCtrl",
                    scope: $scope,
                    resolve: {
                        fileId: function () {
                            return id;
                        },
                        parentFolderId: function () {
                            return currentFolderId;
                        },
                        entity_type: function () {
                            return entity_type
                        },
                        entity_type_id: function () {
                            return entity_type_id
                        },
                        is_public: function () {
                            return is_public
                        }
                    }
                });
            }

           //Response del modal
            $modalInstance.result.then(function (data) {
                if(entity_type == 'general'){
                    $scope.loadGeneralData($scope.currentGeneralFolderId, 1, false);
                }else if(entity_type == 'events'){
                    $scope.loadEventData($scope.currentEventFolderId, 1, false);
                }
            }, function () {
                if (!$scope.$$phase) $scope.$apply();
            });  
        };


    }])

    .controller('ModalDocumentsTypesCtrl', ['$scope', '$uibModalInstance', 'options', '$http', '$uibModal', 'Restangular', 'logService', function ($scope, $uibModalInstance, options, $http, $uibModal, Restangular, logService) {

        logService.debug(options);

        //Estas dos propiedades son para el caso de propuesta de invitados, sino no sale.
        $scope.orderPrintModal = { _sortBy: 'prefered' };
        $scope.showOrder = false;

        $scope.selected = [];
        $scope.configurateJasper = false;
        $scope.options = options;
        logService.debug($scope.options);
        if (typeof (options.params.entity_type_id) !== undefined) $scope.configurateJasper = true; // Si le enviamos el evento o la correspondencia, se permitira configurar el jasper.

        var optionsValues = {
            codes: options.params.documents.codes,
            for_event_guest: options.params.documents.for_event_guest,
            for_event_staff: options.params.documents.for_event_staff,
            for_event_workteam: options.params.documents.for_event_workteam,
            for_correspondence: options.params.documents.for_correspondence,
            // Este modal renderiza la imagen embebida de cada documento
            // como <img>; el endpoint la omite por defecto (AB#2902).
            include_images: true
        };

        $http({
            method: 'get',
            url: (window as any).CONFIG.api_url + 'Documents/GetDocumentsByDocumentsType',
            params: optionsValues
        }).then(function (results, status, headers, config) {
            $scope.documents = results.data.rows;
            $scope.documentsTypes = $scope.documents.map(function (item) { return { id: item.document_type_id, code: item.FK_documents_documents_types.code, name: item.FK_documents_documents_types.name, type:item.type, uid:item.uid } }).filter(function (x, i, a) {
                return a.findIndex(m => m.code === x.code) == i;
            });
            if ($scope.documentsTypes.length > 0) {
                //solo existe un tipo de documentos lo seleccionamos directamente..
                if (typeof ($scope.selected[$scope.documentsTypes[0].id]) === "undefined") {
                    $scope.selected[$scope.documentsTypes[0].id] = { checked: true };
                }
            }

            //$scope.api_url = (window as any).CONFIG.api_url;
            //$scope.type_document = options.params.type_document;
            //$scope.type_result = options.params.type_result;
            $scope.showOrder = ($scope.documentsTypes.filter(function (config) { return config.code == "PROPOSAL_GUEST_LIST"; }).length > 0 ? true : false);
        });

        $scope.setValue = function (document_type_id, document_type_code, document_id, name, url_document_method,type, uid) {
            logService.debug(document_type_id, document_type_code, document_id, name, url_document_method);
            if (typeof ($scope.selected[document_type_id]) === "undefined") {
                $scope.selected[document_type_id] = { checked: true };
            }
            $scope.selected[document_type_id].document_id = document_id;
            $scope.selected[document_type_id].document_name = name;
            $scope.selected[document_type_id].document_type_id = document_type_id;
            $scope.selected[document_type_id].document_type_code = document_type_code;
            $scope.selected[document_type_id].document_url_method = url_document_method;
            $scope.selected[document_type_id].type = type;
            $scope.selected[document_type_id].uid = uid;
            if (document_type_code == "PROPOSAL_GUEST_LIST") $scope.selected[document_type_id].url_params = $scope.orderPrintModal._sortBy;
            if (typeof (options.params.event_guests_id) !== "undefined" && options.params.event_guests_id.length > 0) $scope.selected[document_type_id].url_params = options.params.event_guests_id;
            if (typeof (options.params.persons_ids) !== "undefined" && options.params.persons_ids.length > 0) $scope.selected[document_type_id].url_params = options.params.persons_ids;
        };

        $scope.changeCheck = function (item) {
            angular.forEach($scope.selected, function (element, key, obj) {
                if (key != item) {
                    $scope.selected[key] = { checked: false };
                }
            })
        };


        $scope.onAccept = function () {
            var selectedNew = $scope.selected.filter(function (el) { return el.checked }).map(function (e) { return e; });
            $uibModalInstance.close(selectedNew);
        };
        $scope.onError = function (errorMessage) {
            $uibModalInstance.close(errorMessage);
        };

        $scope.onConfigure = function ($event, document) {
            $event.preventDefault();
            $event.stopPropagation();
            logService.debug(document);

            let $modalInstance = $uibModal.open({
                animation: true,
                template: ReportsPreviewView,
                controller: 'ReportsPreviewCtrl',
                size: 'lg',
                resolve: {
                    document: function () {
                        return document;
                    },/*
                    event: function () {
                        return {
                            id: options.params.event_id
                        };
                    }*/
                    entity_type: function () { return options.params.entity_type; },
                    entity_type_id: function () { return options.params.entity_type_id; }
                }

            });
            $modalInstance.result.then(function (data) {
                let modified = [];
                //añadimos info de parametros
                angular.forEach(data, function (parameter) {
                    parameter.entity_type = options.params.entity_type;
                    parameter.entity_type_id = options.params.entity_type_id;
                    parameter.document_id = document.id;
                    if (parameter.name == 'JasperParameter' && parameter.values != null) {
                        let values = [];
                        var val = {
                            language_id: 1,
                            value: parameter.values
                        };
                        values.push(val);
                        parameter.values = values;
                    }
                    modified.push(parameter);
                });

                //console.log(modified);
                //console.log(modified.some(function (item) { return item.name.includes('$P{P_IMAGE') }));

                //guardar parametros para el evento en cuestion
                Restangular.all('DocumentsConfig').post(modified).then(function (data) {
                    logService.debug(data);
                });
            });
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }])

;
